import dynamic from 'next/dynamic';
import React from 'react';

import LandingLayout from '@/landing/components/LandingLayout';
import UGCGenerator from '@/landing/components/UGCGenerator';
import {
  EXAMPLE_VIDEOS,
  EXAMPLE_VIDEOS_CONFIG,
  EXPLORE_TOOLS,
  FAQ_CONFIG,
  FAQ_LIST,
  FEATURES_CONFIG,
  FEATURES_LIST,
  FOOTER_CTA_CONFIG,
  HERO_CARD_IMAGES,
  HERO_CONFIG,
  HERO_SUPPORTING_CONFIG,
  HERO_SUPPORTING_TOOLS,
  HOW_TO_CONFIG,
  HOW_TO_STEPS,
  SEO_CONFIG,
  USE_CASES_CONFIG,
  USE_CASES_TABS,
  WHY_CHOOSE_CONFIG,
  WHY_CHOOSE_REASONS,
} from '@/landing/dropshipping-video-ads-maker/config';

const TikTokHeroSupportingSection = dynamic(
  () => import('@/landing/components/templates/TikTokHeroSupportingSection'),
);
const HowToSection = dynamic(() => import('@/landing/components/templates/HowToSection'));
const FeaturesSection = dynamic(
  () => import('@/landing/components/templates/FeaturesSection'),
);
const VideoShowcaseSection = dynamic(
  () => import('@/landing/components/templates/VideoShowcaseSection'),
);
const UGCScaleSection = dynamic(
  () => import('@/landing/components/UGCGenerator/UGCScaleSection'),
);
const WhyChooseSection = dynamic(
  () => import('@/landing/components/templates/WhyChooseSection'),
);
const ExploreToolsSection = dynamic(
  () => import('@/landing/ai-twin-generator/seo/ExploreToolsSection'),
);
const FAQSection = dynamic(() => import('@/landing/components/templates/FAQSection'));
const FooterCTASection = dynamic(
  () => import('@/landing/components/templates/FooterCTASection'),
);

const DropshippingVideoAdsMakerPage: React.FC = () => {
  return (
    <LandingLayout seo={SEO_CONFIG}>
      <UGCGenerator
        title={HERO_CONFIG.title}
        subtitle={HERO_CONFIG.subtitle}
        cardImages={HERO_CARD_IMAGES}
      />
      <TikTokHeroSupportingSection
        title={HERO_SUPPORTING_CONFIG.title}
        subtitle={HERO_SUPPORTING_CONFIG.subtitle}
        tools={HERO_SUPPORTING_TOOLS}
        ctaText={HERO_SUPPORTING_CONFIG.ctaText}
      />
      <HowToSection
        title={HOW_TO_CONFIG.title}
        steps={HOW_TO_STEPS}
        ctaText={HOW_TO_CONFIG.ctaText}
        imageUrl={HOW_TO_CONFIG.imageUrl}
      />
      <FeaturesSection
        title={FEATURES_CONFIG.title}
        subtitle={FEATURES_CONFIG.subtitle}
        features={FEATURES_LIST}
        ctaText={FEATURES_CONFIG.ctaText}
      />
      <VideoShowcaseSection
        title={EXAMPLE_VIDEOS_CONFIG.title}
        subtitle={EXAMPLE_VIDEOS_CONFIG.subtitle}
        videos={EXAMPLE_VIDEOS}
        ctaText={EXAMPLE_VIDEOS_CONFIG.ctaText}
        infinite
      />
      <UGCScaleSection
        title={USE_CASES_CONFIG.title}
        subtitle={USE_CASES_CONFIG.subtitle}
        tabs={USE_CASES_TABS}
      />
      <WhyChooseSection
        title={WHY_CHOOSE_CONFIG.title}
        subtitle={WHY_CHOOSE_CONFIG.subtitle}
        reasons={WHY_CHOOSE_REASONS}
        ctaText={WHY_CHOOSE_CONFIG.ctaText}
      />
      <ExploreToolsSection tools={EXPLORE_TOOLS} />
      <FAQSection title={FAQ_CONFIG.title} faqs={FAQ_LIST} />
      <FooterCTASection
        title={FOOTER_CTA_CONFIG.title}
        subtitle={FOOTER_CTA_CONFIG.subtitle}
        ctaText={FOOTER_CTA_CONFIG.ctaText}
      />
    </LandingLayout>
  );
};

export default DropshippingVideoAdsMakerPage;
